// extracted by mini-css-extract-plugin
export var attribution = "_1c-4";
export var authorName = "_1c-5";
export var option = "_1c-g";
export var optionCard = "_1c-v";
export var optionContent = "_1c-w";
export var optionGrid = "_1c-12";
export var optionIcon = "_1c-y";
export var optionIconBox = "_1c-x";
export var optionLabel = "_1c-z";
export var optionList = "_1c-f";
export var optionPill = "_1c-13";
export var optionPillBadge = "_1c-16";
export var optionPillIcon = "_1c-14";
export var optionPillLabel = "_1c-15";
export var optionRadio = "_1c-10";
export var optionRadioInner = "_1c-11";
export var optionReveal = "_1c-i";
export var optionRevealDelay0 = "_1c-j";
export var optionRevealDelay1 = "_1c-k";
export var optionRevealDelay10 = "_1c-t";
export var optionRevealDelay11 = "_1c-u";
export var optionRevealDelay2 = "_1c-l";
export var optionRevealDelay3 = "_1c-m";
export var optionRevealDelay4 = "_1c-n";
export var optionRevealDelay5 = "_1c-o";
export var optionRevealDelay6 = "_1c-p";
export var optionRevealDelay7 = "_1c-q";
export var optionRevealDelay8 = "_1c-r";
export var optionRevealDelay9 = "_1c-s";
export var optionSelected = "_1c-h";
export var questionsBlock = "_1c-18";
export var quote = "_1c-3";
export var spacer = "_1c-b";
export var stepCenteredContent = "_1c-9";
export var stepInner = "_1c-6";
export var stepInnerFullWidth = "_1c-7";
export var stepInnerLockScroll = "_1c-8";
export var stepTransitionFrame = "_1c-a";
export var subtitle = "_1c-e";
export var testimonial = "_1c-2";
export var title = "_1c-c";
export var titleWithAccessory = "_1c-d";
export var trustedBy = "_1c-0";
export var trustedByLabel = "_1c-1";
export var welcomeBlock = "_1c-17";